import ZonesTable from "../../../components/esim/zones/ZonesTable";
import HeaderPage from "../../../components/lines-managements/header/HeaderPage";
import useFetch from "../../../hooks/useFetch";
import { getEsimZoneCanCreate, getEsimZones } from "../../../services/EsimZone.service";

const EsimZones: React.FC = () => {
  const { response, loading } = useFetch(getEsimZones, { initRequest: true, loading: true });
  const canCreate = useFetch(getEsimZoneCanCreate, { initRequest: true });

  return (
    <>
      <HeaderPage
        link={
          canCreate.response?.data
            ? { to: "create", children: "Zonë e re", state: ["Esim", "Zonat", "Zonë e re"] }
            : undefined
        }
      />
      <ZonesTable zones={response?.data ?? []} loading={loading} />
    </>
  );
};

export default EsimZones;
